import logging from 'node-logging-js';
import jsb from 'node-jsb';
import Swiper from 'swiper';

/* Documentation http://idangero.us/swiper/ */
class Gallery {
    constructor(element, options) {
        logging.applyLogging(this, 'Gallery');
        this.logDebug('options:', options);
        this.element = element;
        this.slideNumba = this.element.querySelector('.js-number');
        this.slideWrap = this.element.querySelector('.js-wrap');

        this.initialize();
    }

    initialize() {
        var $numBox = this.slideNumba;
        this.Gallery = new Swiper(this.element, {
            slidesPerView: 1,
            pagination: {
                el: '.swiper-pagination',
                type: "progressbar"
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            on: {
                init: function () {
                    console.log(this);
                    $numBox.innerHTML = this.activeIndex + 1 + '/' + this.slides.length;
                },
                slideChange: function () {
                    $numBox.innerHTML = this.activeIndex + 1 + '/' + this.slides.length;
                }
            },
        });



    }
}

jsb.registerHandler('Gallery', Gallery);
export default Gallery;